import React, { Fragment } from 'react';
import Decorator from '../../functions/decorator';

const TextOnlyBanner = function(props) {
    let isEmpty = false;
    if(!props.children) isEmpty = true;
    if(!props.children.headerText && !props.children.description && !props.children.alternateSection) isEmpty = true;
    return ( isEmpty ? '' : //display nothing if no props given
            <div>
                <h1 className="text-center text-branded">{props.children.headerText}</h1>
                <hr></hr>
                {props.children.description ? Decorator.multiLineParagraph(props.children.description, 'lead') : ''}
                {props.children.alternateSection ? props.children.alternateSection : ''}
            </div>
    )
};

export default TextOnlyBanner;
